import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

type Props = {
    submit: () => void;
    dialogText: React.ReactNode | React.ReactNode[];
    dialogTitle: string;
    open: boolean;
    setOpen: (arg: boolean) => void;
};

const SubmitModal = (props: Props) => {
    const { open, setOpen } = props;
    const { t } = useTranslation();
    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {props.dialogTitle}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogText}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => setOpen(false)}
                    className="e2e-dialog-cancel"
                >
                    {t('common.no')}
                </Button>
                <Button
                    className="e2e-dialog-confirm"
                    onClick={() => {
                        props.submit();
                        setOpen(false);
                    }}
                    autoFocus
                >
                    {t('common.yes')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SubmitModal;
